import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  List,
  Avatar,
  Row,
  Select,
  Typography
} from 'antd'
import { EditOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons'
import React, { useEffect } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
const { Text } = Typography

export const statusList = [
  {
    value: '1',
    label: 'Đã xử lý',
    name: 'Đã xử lý',
    color: 'green'
  },
  {
    value: '0',
    label: 'Chưa xử lý',
    name: 'Chưa xử lý',
    color: 'yellow'
  }
]
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({ form, handleSearch, data, handleSave }) => {
  const user_role = localStorage.getItem('user_role')
  const isAdmin = user_role === 'ADMIN'
  
  useEffect(() => {
    if (data) {
      form.setFieldsValue(data)
    }
  }, [data])
  
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 8 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      onValuesChange={(value, allValues) =>
        console.log('Form Data', value, allValues)
      }
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>

      {/* <Form.Item label="Họ và tên" name="full_name">
        <Input placeholder="Nhập họ và tên" disabled/>
      </Form.Item>

      <Form.Item label="Số điện thoại"  name="phone_number">
        <Input placeholder="Nhập số điện thoai" disabled/>
      </Form.Item>

      <Form.Item label="Vị trí ứng tuyền" name="position">
        <Input placeholder="Nhập vị trí" disabled/>
      </Form.Item>
      <Form.Item label="Lời nhắn" name="note">
        <Input placeholder="Nhập lời nhắn" style={{width: '100%'}} disabled/>
      </Form.Item>
      <Form.Item
        label="Trạng thái"
        name="status"
      >
        <Select placeholder="Chọn trạng thái">
          {statusList.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Divider>Danh sách note</Divider>
      <Form.Item
        label=""
        name="note1"
      >
        <Input.TextArea rows={2} placeholder="Viết bình luận..." />
        </Form.Item>
      
      <Button type="primary" onClick={async() => {
        handleSave()
      }}>
           Thêm Note
        </Button>

        <div
  style={{
    marginTop: 10,
    maxHeight: 250,
    overflowY: "auto",
    paddingTop: 16,
    paddingRight: 8,  
  }}
>
  <Timeline>
    {data?.applicant_note?.map((item) => (
      <Timeline.Item key={item.id}>
        <b>{item.note}</b> <br />
        <small>{item.created_at}</small>
      </Timeline.Item>
    ))}
  </Timeline>
</div> */}

      {/* Họ tên + SĐT */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Họ và tên" name="full_name">
            <Input placeholder="Nhập họ và tên" disabled={!isAdmin} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Số điện thoại" name="phone_number">
            <Input placeholder="Nhập số điện thoại" disabled={!isAdmin} />
          </Form.Item>
        </Col>
      </Row>

      {/* Vị trí + Lời nhắn */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Vị trí ứng tuyển" name="position">
            <Input placeholder="Nhập vị trí" disabled={!isAdmin} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Lời nhắn" name="note">
            <Input
              placeholder="Nhập lời nhắn"
              style={{ width: '100%' }}
              disabled={!isAdmin}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Trạng thái */}
      <Form.Item
        label="Trạng thái"
        name="status"
        labelCol={{ span: 4 }}
        style={{ marginLeft: '-2px' }}
      >
        <Select placeholder="Chọn trạng thái">
          {statusList.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Divider>Danh sách note</Divider>

      {/* Ghi chú mới */}
      <Form.Item label="" name="note1">
        <Input.TextArea rows={2} placeholder="Viết bình luận..." />
      </Form.Item>

      <Button
        type="primary"
        onClick={async () => {
          handleSave()
        }}
      >
        Thêm Note
      </Button>

      {/* Timeline Note */}
      <div
        style={{
          marginTop: 10,
          maxHeight: 250,
          overflowY: 'auto',
          paddingTop: 16,
          paddingRight: 8
        }}
      >
        {/* <Timeline>
      {data?.applicant_note?.map((item) => (
        <Timeline.Item key={item.id}>
          <div style={{display: 'flex', alignItems: 'center', gap: 5 }}>
          <b>{item.user_created}</b> <br />
          <small style={{fontSize: 14, fontWeight: 500}}>{item.created_at ? dayjs(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ''}</small>
          </div>
          <small style={{fontSize: 14, fontWeight: 500}}>{item.note}</small>
        </Timeline.Item>
      ))}
    </Timeline> */}
        <List
          dataSource={data?.applicant_note}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar icon={<UserOutlined />} />}
                title={
                  <Text strong>
                    {item.user_created}
                    <Text type="secondary" style={{ marginLeft: 10 }}>
                      {/* {item.created_at ? dayjs(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ''} */}
                      {item.created_at
                        ? dayjs(item.created_at.replace('Z', '')).format(
                            'HH:mm:ss DD/MM/YYYY'
                          )
                        : ''}{' '}
                    </Text>
                  </Text>
                }
                description={item.note}
              />
            </List.Item>
          )}
        />
      </div>
    </Form>
  )
}

export default FormPost
